import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-solid-svg-icons';

export default function DropzoneTarget() {
  return <React.Fragment>
    <FontAwesomeIcon
      className="right-buffer-sm text-muted fa-fw"
      icon={faImage}
      size="lg"
    />

    <span className="text-muted">
      Click or drag files or folders here to upload them.
    </span>
  </React.Fragment>;
}
